module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ef6Qd"))).then(() => parcelRequire('3a9aZ'));